var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google 1",
    clipPath: "url(#clip0_355_26920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9911 7.64036C14.9911 7.02582 14.9401 6.57736 14.8296 6.1123H7.64844V8.88604H11.8636C11.7787 9.57536 11.3198 10.6134 10.2999 11.311L10.2856 11.4039L12.5562 13.1227L12.7135 13.1381C14.1582 11.8342 14.9911 9.91583 14.9911 7.64036Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.6492 14.9484C9.7143 14.9484 11.448 14.284 12.7143 13.138L10.3007 11.3109C9.65483 11.7511 8.78797 12.0584 7.6492 12.0584C5.62657 12.0584 3.9099 10.7546 3.29795 8.95245L3.20825 8.9599L0.847282 10.7454L0.816406 10.8293C2.07417 13.2709 4.65771 14.9484 7.6492 14.9484Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.29737 8.95225C3.13591 8.4872 3.04246 7.98888 3.04246 7.47401C3.04246 6.95908 3.13591 6.46082 3.28888 5.99576L3.2846 5.89672L0.894048 4.08252L0.815834 4.11887C0.29745 5.13206 0 6.26983 0 7.47401C0 8.67819 0.29745 9.8159 0.815834 10.8291L3.29737 8.95225Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.6492 2.89002C9.08542 2.89002 10.0542 3.49626 10.6066 4.00288L12.7653 1.9433C11.4395 0.739122 9.7143 0 7.6492 0C4.65771 0 2.07417 1.67754 0.816406 4.1191L3.28945 5.99599C3.9099 4.19387 5.62657 2.89002 7.6492 2.89002Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_26920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.23f7b5e6b6f33a8b61fbab615487d442.svg";
export { ForwardRef as ReactComponent };